import { EndsInFilterEnum } from "~/types/endsIn";
import type { IOption } from "~/types/option";

export const labelByEndsInFilterEnum: Record<EndsInFilterEnum, string> = {
  [EndsInFilterEnum.ALL]: "All",
  [EndsInFilterEnum.M15]: "15 Minutes",
  [EndsInFilterEnum.H1]: "1 Hour",
  [EndsInFilterEnum.H4]: "4 Hours",
  [EndsInFilterEnum.TODAY]: "Today",
  [EndsInFilterEnum.H24]: "24 Hours",
  [EndsInFilterEnum.WEEKEND]: "This Weekend",
  [EndsInFilterEnum.D7]: "7 Days",
  [EndsInFilterEnum.D30]: "30 Days",
  [EndsInFilterEnum.CUSTOM]: "Custom Date",
};

export const endsInFilterOptions: IOption<EndsInFilterEnum>[] = Object.values(
  EndsInFilterEnum
).map((value) => ({
  label: labelByEndsInFilterEnum[value],
  value,
}));
